import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaSnowflake,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaClock,
  FaShieldAlt,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: "AC Installation", href: "#" },
      { name: "AC Repair", href: "#" },
      { name: "Maintenance", href: "#" },
      { name: "Commercial HVAC", href: "#" },
      { name: "Residential AC", href: "#" },
      { name: "Emergency Service", href: "#" },
    ],
    company: [
      { name: "About Us", href: "#" },
      { name: "Our Team", href: "#" },
      { name: "Careers", href: "#" },
      { name: "Testimonials", href: "#" },
      { name: "Blog", href: "#" },
      { name: "Contact", href: "#" },
    ],
    support: [
      { name: "FAQ", href: "#" },
      { name: "Warranty", href: "#" },
      { name: "Service Areas", href: "#" },
      { name: "Emergency Service", href: "#" },
      { name: "Customer Portal", href: "#" },
      { name: "Support Center", href: "#" },
    ],
  };

  const socialLinks = [
    { icon: <FaFacebook />, href: "#", label: "Facebook" },
    { icon: <FaTwitter />, href: "#", label: "Twitter" },
    { icon: <FaInstagram />, href: "#", label: "Instagram" },
    { icon: <FaLinkedin />, href: "#", label: "LinkedIn" },
  ];

  return (
    <footer className="bg-dark text-white">
      {/* Main Footer */}
      <div className="py-5">
        <Container>
          <Row className="g-4">
            {/* Company Info */}
            <Col lg={4} md={12} className="mb-4 mb-lg-0">
              <div className="mb-4">
                <Link to="/">
                  <img
                    src="/logo.png"
                    alt="Moiz AC Repair Logo"
                    style={{ height: "60px", marginBottom: "15px" }}
                  />
                </Link>
                <p className="text-muted">
                  Your trusted partner for professional HVAC services. We
                  specialize in commercial and residential air conditioning
                  solutions with unmatched expertise and reliability.
                </p>
              </div>
            </Col>

            {/* Services */}
            <Col lg={2} md={6}>
              <h5 className="fw-bold mb-3">Services</h5>
              <ul className="list-unstyled">
                {footerLinks.services.map((link, index) => (
                  <li key={index} className="mb-2">
                    <Link
                      to={link.href}
                      className="text-muted text-decoration-none hover-text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Company */}
            <Col lg={2} md={6}>
              <h5 className="fw-bold mb-3">Company</h5>
              <ul className="list-unstyled">
                {footerLinks.company.map((link, index) => (
                  <li key={index} className="mb-2">
                    <Link
                      to={link.href}
                      className="text-muted text-decoration-none hover-text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Support */}
            <Col lg={2} md={6}>
              <h5 className="fw-bold mb-3">Support</h5>
              <ul className="list-unstyled">
                {footerLinks.support.map((link, index) => (
                  <li key={index} className="mb-2">
                    <Link
                      to={link.href}
                      className="text-muted text-decoration-none hover-text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Newsletter & Social */}
            <Col lg={2} md={6}>
              <h5 className="fw-bold mb-3">Connect</h5>
              <p className="text-muted mb-3">Follow us on social media</p>

              <div className="d-flex gap-2 mb-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="text-muted text-decoration-none d-flex align-items-center justify-content-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      border: "1px solid #6c757d",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "var(--primary-color)";
                      e.target.style.borderColor = "var(--primary-color)";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.borderColor = "#6c757d";
                      e.target.style.color = "#6c757d";
                    }}
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>

              <div className="d-flex align-items-center">
                <FaShieldAlt className="text-success me-2" />
                <span className="small">Licensed & Insured</span>
              </div>
            </Col>

            {/* Contact Info */}
            <Col lg={4} md={6}>
              <div className="mb-4">
                <h5 className="fw-bold mb-3">Contact Info</h5>
                <div className="d-flex align-items-center mb-3">
                  <FaPhone className="text-primary me-3" />
                  <div>
                    <p className="mb-0 fw-semibold">Phone</p>
                    <a
                      href="tel:+923054743725"
                      className="text-muted text-decoration-none"
                    >
                      +92 305 4743725
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <FaEnvelope className="text-primary me-3" />
                  <div>
                    <p className="mb-0 fw-semibold">Email</p>
                    <a
                      href="mailto:miansaif351@gmail.com"
                      className="text-muted text-decoration-none"
                    >
                      miansaif351@gmail.com
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <FaMapMarkerAlt className="text-primary me-3" />
                  <div>
                    <p className="mb-0 fw-semibold">Address</p>
                    <p className="text-muted mb-0">Lahore, Punjab, Pakistan</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Bottom Footer */}
      <div className="border-top border-secondary py-3">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <p className="text-muted mb-0 small">
                © {currentYear} ProCool AC Services. All rights reserved.
              </p>
            </Col>
            <Col md={6} className="text-md-end">
              <div className="d-flex flex-wrap gap-3 justify-content-md-end">
                <Link to="#" className="text-muted text-decoration-none small">
                  Privacy Policy
                </Link>
                <Link to="#" className="text-muted text-decoration-none small">
                  Terms of Service
                </Link>
                <Link to="#" className="text-muted text-decoration-none small">
                  Cookie Policy
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
